export default __webpack_public_path__ + "static/media/speed.9fd84803.webp";